import SwiperCore, { Autoplay, Pagination, Thumbs } from "swiper";
import "swiper/css";
import "swiper/css/pagination";

SwiperCore.use([Autoplay, Pagination, Thumbs]);
